import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import ImageCarousel from '../ImageCarousel';
import ImageCard from './ImageCard';
import { OrderReviewContext } from './OrderReviewContext';

const propTypes = {
  classes: PropTypes.object.isRequired,
};

function AllPhotos({ classes, saveAnswersAsync, removeAnswersAsync, hideAllPhotos, taggedPhotos }) {
  const { state } = useContext(OrderReviewContext);
  const [photosWithoutLocation, setPhotosWithoutLocation] = useState([]);
  const [formHeaders, setFormHeaders] = useState(state.formHeaders);
  const [images, setImages] = useState(
    state.formHeaders
      .filter(fh => fh.images)
      .map(fh => fh.images)
      .flat()
      .sort(i => i.formQaImageId),
  );

  const getPhotosWithoutLocation = () => {
    let allImgs = state.formHeaders
      .filter(fh => fh.images)
      .map(fh => fh.images)
      .flat()
      .sort(i => i.formQaImageId);

    let imgWithLoc = state.formHeaders
      .filter(fh => fh.formDefinitions)
      .map(fh => fh.formDefinitions.filter(fd => fd.answerType === 'Picture'))
      .flat()
      .filter(x => x.answers.length > 0)
      .map(x => x.answers[0])
      .filter(x => x.images.length > 0)
      .map(x => x.images)
      .flat();

    // let imgs = allImgs.filter(x => imgWithLoc.some(z => z.formQaImageId === x.formQaImageId));
    setPhotosWithoutLocation(imgWithLoc);
  };

  useEffect(() => {
    getPhotosWithoutLocation();
  }, [state.formHeaders]);

  return (
    <>
      <ImageCarousel
        images={
                state.formHeaders
                .filter(fh => fh.images)
                .map(fh => fh.images)
                .flat()
                .filter(x => hideAllPhotos ? !x.hideImage : x)
                .filter(x => (taggedPhotos ? !photosWithoutLocation.some(z => z.formQaImageId === x.formQaImageId) && !x.hideImage : x))
                .sort(i => i.formQaImageId)
                .map(image => {
                  image.src = image.imageUri.replace('fieldrepimage', 'fieldrepimagelarge').replace('/raw/', '/large/');
                  return image;
                })
        }
        getBadgeContent={image =>
          state.formHeaders
            .filter(fh => fh.formDefinitions)
            .map(fh =>
              fh.formDefinitions.filter(
                fd =>
                  fd.answerType !== 'Picture' &&
                  fd.answers &&
                  fd.answers.length > 0 &&
                  fd.answers.some(
                    a =>
                      a.images &&
                      a.images.length > 0 &&
                      a.images.some(i => i && i.formQaImageId === image.formQaImageId),
                  ),
              ),
            )
            .flat().length
        }
        onClick={function scrollToImage({ formQaImageId }) {
          let element = document.getElementById(`scroll-to-id-${formQaImageId}`);
          let container = document.getElementById('image-cards-container');
          const offsetTop = element.offsetTop;
          container.scroll({
            top: offsetTop - 245,
            behavior: 'smooth',
          });
        }}
      />
      <Grid container className={classes.overflow}>
        <Grid id="image-cards-container" item xs={12} className={classes.imageCardsContainer}>
          <Grid container spacing={0}>
            {state.formHeaders
              .filter(fh => fh.images)
              .map(fh => fh.images)
              .flat()
              .sort(i => i.formQaImageId)
              .filter(x => (hideAllPhotos ? !x.hideImage : x))
              .filter(x => (taggedPhotos ? !photosWithoutLocation.some(z => z.formQaImageId === x.formQaImageId) && !x.hideImage : x))
              .map(image => (
                <ImageCard
                  key={image.formQaImageId}
                  image={image}
                  saveAnswers={saveAnswersAsync}
                  removeAnswers={removeAnswersAsync}
                  formHeader={state.formHeaders.find(fh =>
                    fh.images.find(i => i.formQaImageId === image.formQaImageId),
                  )}
                />
              ))}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

const styles = theme => ({
  overflow: {
    overflowY: 'auto',
    flex: 1,
  },
  imageCardsContainer: {
    overflowY: 'auto',
    overflowX: 'hidden',
    height: '100%',
    padding: '1px 1px 0px 1px',
  },
});

AllPhotos.propTypes = propTypes;
export default withStyles(styles)(withRouter(AllPhotos));
